/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * graphic object
 * @export
 * @interface GetCharactersCharacterIdMedalsGraphic
 */
export interface GetCharactersCharacterIdMedalsGraphic {
    /**
     * color integer
     * @type {number}
     * @memberof GetCharactersCharacterIdMedalsGraphic
     */
    color?: number;
    /**
     * graphic string
     * @type {string}
     * @memberof GetCharactersCharacterIdMedalsGraphic
     */
    graphic: string;
    /**
     * layer integer
     * @type {number}
     * @memberof GetCharactersCharacterIdMedalsGraphic
     */
    layer: number;
    /**
     * part integer
     * @type {number}
     * @memberof GetCharactersCharacterIdMedalsGraphic
     */
    part: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdMedalsGraphic interface.
 */
export function instanceOfGetCharactersCharacterIdMedalsGraphic(value: object): value is GetCharactersCharacterIdMedalsGraphic {
    if (!('graphic' in value) || value['graphic'] === undefined) return false;
    if (!('layer' in value) || value['layer'] === undefined) return false;
    if (!('part' in value) || value['part'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdMedalsGraphicFromJSON(json: any): GetCharactersCharacterIdMedalsGraphic {
    return GetCharactersCharacterIdMedalsGraphicFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdMedalsGraphicFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdMedalsGraphic {
    if (json == null) {
        return json;
    }
    return {
        
        'color': json['color'] == null ? undefined : json['color'],
        'graphic': json['graphic'],
        'layer': json['layer'],
        'part': json['part'],
    };
}

export function GetCharactersCharacterIdMedalsGraphicToJSON(json: any): GetCharactersCharacterIdMedalsGraphic {
    return GetCharactersCharacterIdMedalsGraphicToJSONTyped(json, false);
}

export function GetCharactersCharacterIdMedalsGraphicToJSONTyped(value?: GetCharactersCharacterIdMedalsGraphic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'color': value['color'],
        'graphic': value['graphic'],
        'layer': value['layer'],
        'part': value['part'],
    };
}

